import React, { CSSProperties, ReactElement } from 'react';
import { Card } from 'antd';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import FaIcon from './FaIcon';

export interface HelpProps {
  text: string | ReactElement;
  style?: CSSProperties;
  block?: boolean;
  showHelpText?: boolean;
}

function Help({ text, style, block, showHelpText }: HelpProps) {
  if (!showHelpText || !text || (typeof text === 'string' && !text.length)) {
    return null;
  }

  if (block) {
    return (
      <Card
        className="help-text"
        type="inner"
        size="small"
        title={
          <>
            <FaIcon icon={faQuestionCircle} />
            &nbsp; Help
          </>
        }
        style={style}
      >
        {text}
      </Card>
    );
  }

  return (
    <div className="help-text" style={{ marginTop: 5, ...style }}>
      <FaIcon icon={faQuestionCircle} />
      &ensp;
      {text}
    </div>
  );
}
export default Help;
